var map = {
	"./brand/reduced": 199,
	"./brand/reduced.svg": 199,
	"./brand/regular": 200,
	"./brand/regular.svg": 200,
	"./favicons/favicon-16x16": 201,
	"./favicons/favicon-16x16.png": 201,
	"./favicons/favicon-32x32": 202,
	"./favicons/favicon-32x32.png": 202,
	"./favicons/favicon-96x96": 203,
	"./favicons/favicon-96x96.png": 203,
	"./menu/event_logo": 204,
	"./menu/event_logo.png": 204,
	"./menu/logo": 205,
	"./menu/logo.svg": 205,
	"./menu/user": 206,
	"./menu/user.svg": 206,
	"./spinner": 207,
	"./spinner.svg": 207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 211;